export default (html) => {
  html += '' // force string just in case
  return html.replace(/<[^>]+/g, function (match) {
    return match.replace(/ on\w+="[^"]*"/g, '')
  }).replace(/<script[^>]*>/g, '')
}
